<template>
	<div class="under-team">
		<el-card shadow="never">
			<template slot="header">
				<el-row type="flex" justify="space-between">
					<span class="row" align-y="center" gutter="5">
						<b>成立小組</b>
						<div class="team-number layout-row layout-hv-center bg-black-gray1 color-white">{{num+1}}</div>
					</span>
					<el-button type="danger" size="mini" v-if="!isOnly" @click="removeTeam">點選刪除小組</el-button>
				</el-row>
			</template>
			<el-form label-position="left" label-width="100px" :model="ruleForm" :rules="rules" ref="setUpUnderForm">
				<el-form-item label="小組名稱" prop="teamName">
					<el-input v-model="ruleForm.teamName" placeholder="此小組名稱為方便輔導員管理故事資料，非故事名稱"></el-input>
				</el-form-item>
				<el-form-item :label="(i==0)?'小組成員':''" :prop="'members.' + i " v-for="(member, i) in ruleForm.members" :key="i" :rules="{required: true, validator: validateMember, trigger: 'blur'}">
					<el-row class="member" type="flex" :gutter="5">
						<el-col :span="10">
							<el-input placeholder="輸入姓名" v-model="member.name"></el-input>
						</el-col>
						<el-col :span="8">
							<el-input placeholder="輸入年級" v-model="member.grade"></el-input>
						</el-col>
						<el-col :span="2">
							<span>年級</span>
						</el-col>
						<el-col :span="8">
							<el-input placeholder="輸入年齡" v-model="member.age"></el-input>
						</el-col>
						<el-col :span="2">
							<span>歲</span>
						</el-col>
						<el-col :span="2">
							<el-button v-if="ruleForm.members.length > 1" icon="el-icon-minus" type="info" circle size="mini" @click="removeMember(i)"></el-button>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item>
					<div class="row" align-y="center" gutter="20">
						<el-button icon="el-icon-plus" type="primary" circle size="mini" @click="addMember"></el-button>
						<span class="color-text3">* 不限挑戰人數，但建議人數為五人。</span>
					</div>
				</el-form-item>
				<div class="instructor">
					<el-form-item :label="'第' + (i+1)+ '位輔導員'" v-for="(instructor,i) in ruleForm.instructors" :key="i">
						<el-row type="flex" :gutter="10">
							<el-col>
								<div>{{instructor.name}}&emsp;{{instructor.phone}}</div>
							</el-col>
							<el-col v-if="i > 0">
								<el-button icon="el-icon-minus" type="info" circle size="mini" @click="removeInstructor(i)"></el-button>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item label="新增輔導員">
						<div class="row" align-x="left">
							<div class="button-tp bind-account-btn color-white bg-blue1" @click="dialogVisible = true">已有帳號，點選帶入資料</div>
						</div>
					</el-form-item>
				</div>
			</el-form>
		</el-card>
		<el-dialog class="instructor-dialog" :visible.sync="dialogVisible" :before-close="handleDialogClose">
			<div class="title">
				<span class="center">輸入帳號(email)，連結另一位夥伴</span>
			</div>
			<div class="input-box">
				<el-input placeholder="輸入Email" v-model="newInstructorEmail" @keyup.enter.native="searchInstructor"></el-input>
			</div>
			<div>
				<el-row type="flex" justify="center">
					<el-button type="info" @click="handleDialogClose">取消</el-button>
					<el-button type="danger" class="bg-pink1 color-white" @click="searchInstructor">確定</el-button>
				</el-row>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import uuid from "uuid";
import validator from "@/libs/validator";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
	props: ["num", "story", "isOnly"],
	data() {
		return {
			dialogVisible: false,
			ruleForm: {
				teamName: "",
				members: [
					{
						index: uuid.v4(),
						name: "",
						grade: "",
						age: ""
					}
				],
				instructors: [
					{
						id: "",
						name: ""
					}
				]
			},
			rules: {
				teamName: [
					{ required: true, message: "請輸入小組名稱", trigger: "blur" }
				]
			},
			newInstructorEmail: ""
		};
	},
	computed: {
		...mapState("user", ["userInfo"])
	},
	methods: {
		...mapMutations("story", ["setCreateStory", "deleteCreateStory"]),
		...mapActions("story", ["searchAccount"]),
		handleDialogClose() {
			this.newInstructorEmail = "";
			this.dialogVisible = false;
		},
		validateMember(rule, value, callback) {
			if (value.name === "") {
				callback(new Error("請輸入姓名"));
			} else if (value.grade === "") {
				callback(new Error("請輸入年級"));
			} else if (value.age === "") {
				callback(new Error("請輸入年紀"));
			} else if (parseInt(value.age) >= 18) {
				callback(new Error("挑戰者需要未滿18歲"));
			}
			callback();
		},
		async searchInstructor() {
			if (validator.isEmail(this.newInstructorEmail)) {
				let data = {
					account: this.newInstructorEmail
				};
				try {
					let res = await this.searchAccount(data);
					let instructor = {
						index: uuid.v4(),
						...res.data,
					};
					this.ruleForm.instructors.push(instructor);
					this.newInstructorEmail = "";
					this.dialogVisible = false;
				} catch (e) {
					this.$message.error(e);
				}
			} else {
				this.$message.error("請輸入完整輔導員帳號email!");
			}
		},
		addMember() {
			let data = {
				index: uuid.v4(),
				name: "",
				grade: "",
				age: ""
			};
			this.ruleForm.members.push(data);
		},
		removeMember(i) {
			_.pullAt(this.ruleForm.members, i);
			this.ruleForm.members = _.cloneDeep(this.ruleForm.members);
		},
		removeInstructor(i) {
			_.pullAt(this.ruleForm.instructors, i);
			this.ruleForm.instructors = _.cloneDeep(this.ruleForm.instructors);
		},
		validatedAll() {
			var result = false;
			this.$refs["setUpUnderForm"].validate(valid => {
				if (valid) {
					result = true;
					this.setStoreCreateStory();
				} else {
					result = false;
				}
			});
			return result;
		},
		setStoreCreateStory() {
			let data = {
				index: this.story.index,
				is_18: this.story.is_18,
				team_name: this.ruleForm.teamName,
				team_members: _.cloneDeep(this.ruleForm.members),
				counselors: _.cloneDeep(this.ruleForm.instructors)
			};
			this.setCreateStory(data);
		},
		removeTeam() {
			this.deleteCreateStory(this.story.index);
		},
		init() {
			this.ruleForm.instructors[0].index = uuid.v4();
			this.ruleForm.instructors[0].id = this.userInfo.id;
			this.ruleForm.instructors[0].name = this.userInfo.name;
			this.ruleForm.instructors[0].phone = this.userInfo.phone;
			this.ruleForm.instructors[0].email = this.userInfo.email;
			this.ruleForm.instructors[0].wade_giles = this.userInfo.wade_giles;
		}
	},
	created() {
		this.init();
	},
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.under-team {
	.team-number {
		border-radius: 100%;
		width: 20px;
		height: 20px;
	}

	.instructor {
		margin-top: 30px;
	}

	.member {
		margin-bottom: 8px;
	}
}

.bind-account-btn {
	padding: 0 10px;
	height: 25px;
}

.instructor-dialog {
	.title {
		font-size: 14px;
		font-weight: 500;
		margin-bottom: 22px;
	}

	.input-box {
		margin-bottom: 23px;
	}
}
</style>